import { toastParams } from "../utils/toastParams"
import { removeToast } from "./removeToast"

interface HTMLSpanElementWithTimeout extends HTMLSpanElement {
    timeoutId?: number;
}

export const createToast = (id: string, containerToast: HTMLElement) => {
    const { text, icon, title, status, links } = toastParams[id] as Exclude<typeof toastParams[string], number>
    const toast: HTMLSpanElementWithTimeout = document.createElement('span')
    toast.className = `toast ${status}`
    /**
     * Comment icon html not working
     * <div class="toast__icon">
     *             <svg class="icon">
     *                 <use xlink:href="{{ vite_asset('images/sprite.svg#${icon}', true) }}"></use>
     *             </svg>
     *         </div>
     */
    toast.innerHTML = `
        <div class="toast__body">
            <p class="toast__body__title">${title}</p> 
            ${text ? `<p class="toast__body__paragraph">${text}</p>` : ''}
            ${links && links.length > 0 ? `
            <span class="toast__body__links">
                ${links.map(link => `<a href="${link.href}">${link.content}</a>`).join('')}
            </span>
            ` : ''}
        </div>
    `

    containerToast.appendChild(toast)

    toast.timeoutId = setTimeout(() => {
        removeToast(toast)
    }, typeof toastParams.timer === "number" ? toastParams.timer : 15000)
}
